// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"7063b711","453":"79a84f2c","587":"2535e2e0","659":"261db57e","768":"d890b5eb","920":"258dfe3b"}[chunkId] + ".chunk.js";
};